import type { SearchParams } from '@/server/searchParams.ts';

export const SEARCH_ADDITIONAL_PARAMETER = 'SEARCH_ADDITIONAL_PARAMETER';
export const SEARCH_ADDITIONAL_PARAMETER_VERSION = '1.0';

const PARAMETER_NAMES_TO_TRACK = ['label', 'memberID', 'kayakbaggageoption'];

export const shouldTrackAdditionalParams = (searchParams: SearchParams): boolean =>
  !!PARAMETER_NAMES_TO_TRACK.find((paramName) => !!searchParams?.[paramName]);

export type SearchAdditionalParameterParams = {
  searchId: string;
  searchParams: SearchParams;
};

export type SearchAdditionalParameterPayload = {
  searchId: string;
  aff_marker_1: string;
  aff_value_1: string;
  aff_marker_2: string;
  aff_value_2: string;
  aff_marker_3: string;
  aff_value_3: string;
};

export const createSearchAdditionalParameterPayload = (
  params: SearchAdditionalParameterParams
): SearchAdditionalParameterPayload => {
  const { searchId, searchParams } = params;

  const affMarker1 = PARAMETER_NAMES_TO_TRACK[0] || '';
  const affValue1 = searchParams?.[affMarker1] || '';
  const affMarker2 = PARAMETER_NAMES_TO_TRACK[1] || '';
  const affValue2 = searchParams?.[affMarker2] || '';
  const affMarker3 = PARAMETER_NAMES_TO_TRACK[2] || '';
  const affValue3 = searchParams?.[affMarker3] || '';

  const payload = {
    searchId,
    aff_marker_1: affMarker1,
    aff_value_1: affValue1,
    aff_marker_2: affMarker2,
    aff_value_2: affValue2,
    aff_marker_3: affMarker3,
    aff_value_3: affValue3,
  };

  return payload;
};
